module.exports = __webpack_public_path__ + "static/media/search@small.9dfc97b0.svg";